import actions from "./actions";

const {FETCH_ALL_STUDENTS_RESULTS_ACCESS, FETCH_ALL_TEACHERS_ACCESS} = actions;

const initState = {
    access: [],
    teacherAccess: [],
};

const StudentsResultAccessReducer = (state = initState, action) => {
    const {type, data} = action;
    switch (type) {
        case FETCH_ALL_STUDENTS_RESULTS_ACCESS:
            return {
                ...state,
                access: data
            }
        case FETCH_ALL_TEACHERS_ACCESS:
            return {
                ...state,
                teacherAccess: data
            }
        default:
            return state;
    }
}

export default StudentsResultAccessReducer;